import { FC, PropsWithChildren, createContext, useContext, useDebugValue } from 'react';

export enum ElementType {
  clause,
  condition,
}

type ElementIndexContextState = {
  indexes: Record<ElementType, number | null>;
};

export const elementIndexDefaultState: ElementIndexContextState = {
  indexes: {
    [ElementType.clause]: null,
    [ElementType.condition]: null,
  },
};

const ElementIndexContext = createContext(elementIndexDefaultState);

export const useElementIndexContext = () => useContext(ElementIndexContext);

export const useIndex = (elementType: ElementType) => {
  const index = useElementIndexContext().indexes[elementType];
  useDebugValue(index);
  return index;
};

type ElementIndexContextProviderProps = {
  index: number;
  type: ElementType;
};

export const ElementIndexContextProvider: FC<
  PropsWithChildren<ElementIndexContextProviderProps>
> = ({ index, type, children }) => {
  const { indexes } = useElementIndexContext();
  return (
    <ElementIndexContext.Provider value={{ indexes: { ...indexes, [type]: index } }}>
      {children}
    </ElementIndexContext.Provider>
  );
};
